<template>
  <div class="inner_app">
    <div
      id="lemontreeWrap"
      ref="wrapLemontree"
      :class="[
        'wrap_lemontree',
        { 'active_snb' : getIsActiveGnb && isRequiresAuth },
        { 'wrap_full' : isBodyFull },
        { 'wrap_middle' : isBodyMiddle },
      ]">
      <Header
        v-if="isRequiresAuth"
        @onClickSnb="onClickSnb()"/>
      <Snb
        v-if="isRequiresAuth"/>
      <Content
        :isBodyBg="isBodyBg"
        :isBodyMiddle="isBodyMiddle">
        <slot />
      </Content>
      <Footer
        v-if="isRequiresAuth"/>
    </div>
    <slot name="popup" />
  </div>
</template>

<script>
import Header from '@lemontree-ai/lemontree-admin-common-front/components/layout/header/Header';
import Snb from '@lemontree-ai/lemontree-admin-common-front/components/layout/header/Snb';
import Content from '@lemontree-ai/lemontree-admin-common-front/components/layout/content/Content';
import Footer from '@lemontree-ai/lemontree-admin-common-front/components/layout/footer/Footer.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  name:'PageWithLayout',
  components:{
    Header,
    Snb,
    Content,
    Footer
  },
  props:{
    isBodyBg:{
      type: Boolean,
      default: true
    },
    isBodyFull:{
      type: Boolean,
      default: false
    },
    isBodyMiddle:{
      type: Boolean,
      default: false
    },
  },
  mounted(){
    this.setMobile();
  },
  computed:{
    ...mapGetters('commonViewport', [ 'getWindowWidth' ]),
    ...mapGetters('commonGnb', [ 'getIsActiveGnb',]),
    isRequiresAuth(){
      return this.$route.meta.requiresAuth
    },
  },
  watch:{
    getWindowWidth(){
      this.setMobile();
    }
  },
  methods:{
    ...mapActions('commonGnb', [ 'fetchGnbAction' ]),
    setMobile(){
      if(this.getWindowWidth <= 1240){
        this.fetchGnbAction(false);
      }
    },
    onClickSnb(){
      this.fetchGnbAction(!this.getIsActiveGnb);
    },
  }
}
</script>

<style>
.wrap_lemontree{position:relative;min-height:100%}

/* .head_lemontree, */
.foot_lemontree{margin-left:50px;transition:0.2s}
.cont_lemontree{padding-left:50px;transition:0.2s}
.snb_lemontree{width:50px;transition:0.2s}

/* .active_snb .head_lemontree, */
.active_snb .foot_lemontree{margin-left:270px}
.active_snb .cont_lemontree{padding-left:270px}
.active_snb .snb_lemontree{width:270px}

.snb_lemontree .tit_logo .txt_logo,
.snb_lemontree .user_lemontree .txt_user,
.snb_lemontree .list_snb .txt_menu{display:none;transition:0.2s}

.active_snb .snb_lemontree .tit_logo .txt_logo,
.active_snb .snb_lemontree .user_lemontree .txt_user,
.active_snb .snb_lemontree .list_snb .txt_menu{display:inline-block;vertical-align:top}

/* 모바일 */
/* @media all and (max-width:1240px){
  .foot_lemontree{margin-left:0}
  .cont_lemontree{padding-left:0}
  .snb_lemontree{width:0;transition:0s}
  .snb_lemontree .inner_snb{width:0;transition:0.2s}

  .active_snb .foot_lemontree{margin-left:0}
  .active_snb .cont_lemontree{padding-left:0}
  .active_snb .snb_lemontree{width:100%}
  .active_snb .snb_lemontree .inner_snb{width:100%;max-width:320px}
} */
</style>